import { useEffect } from 'react';

declare global {
  interface Window {
    fbAsyncInit: () => void;
    FB: any;
  }
} 
function FacebookSDKLoader() {
  useEffect(() => {
    if (document.getElementById('facebook-jssdk')) return;

    window.fbAsyncInit = function () {
      window.FB.init({
        appId: '1146833856757655',
        xfbml: true,
        version: 'v22.0'
      });
      window.FB.AppEvents.logPageView();
    };

    const script = document.createElement('script');
    script.id = 'facebook-jssdk';
    script.src = 'https://connect.facebook.net/en_US/sdk.js';
    document.body.appendChild(script);
  }, []);

  return null;
}

export default FacebookSDKLoader;
